import { hasWindow } from "@omni/utils/dom.utils";
import axios, { AxiosInstance } from "axios";
import { AxiosCacheInstance, setupCache } from "axios-cache-interceptor";

import { Config } from "@/utils/config.utils";

import { ExtendedAxiosRequestConfig } from "./api.types";
import * as Mappers from "./mappers/default.mapper";

const language = (() => {
    if (typeof window === "undefined") {
        return "en-US";
    }

    if (navigator.languages?.length) {
        return navigator.languages[0];
    }

    return navigator.language || (navigator as any).userLanguage;
})();

const defaultAxiosSettings = (endPoint: string = "") => {
    const API_BASE = Config.general["api-base-url"];
    if (!API_BASE && hasWindow()) throw new ReferenceError("NO API DEFINED");

    return {
        baseURL: `${API_BASE}${endPoint}`,
        withCredentials: true,
        headers: {
            "Content-Type": "application/json",
            "Accept-Language": language,
            LANGUAGE: Config.getLocale()
        },
        validateStatus: (status: number) => status >= 200 && status < 400
    };
};

export const create = (
    endPoint: string = "",
    withCache: boolean = false,
    axiosSettings: Partial<ExtendedAxiosRequestConfig> = {
        mapper: Mappers.Default
    }
): AxiosInstance | AxiosCacheInstance => {
    const newSettings = { ...defaultAxiosSettings(endPoint), ...axiosSettings };

    const axiosObj = axios.create(newSettings);
    const newAxios = withCache ? setupCache(axiosObj) : axiosObj;

    return newAxios;
};

const createExternal = () => {
    return axios.create({
        withCredentials: false,
        headers: {
            "Content-Type": "application/json"
        },
        validateStatus: (status) => status >= 200 && status < 400
    });
};

export const ExternalAPI = createExternal();
